<template>
    <div class="relative transition items-center inline-block">

          <div v-show="isHidden">
            <p>
              {{content}}<a v-on:click="isHidden = !isHidden" :class="['align-middle cursor-pointer', buttonsize]"><i :class="['material-icons align-middle mx-1', buttonsize]">{{buttonicon}}</i>{{buttonname}}</a>
            </p>
          </div>
          <div v-if="!isHidden" class="dropdown flex flex-col w-64 transition items-center">
              
              <div class="flex-1 pr-1 w-full">
                <v-select
                  :options="options"
                  label="name"
                  v-model="selected"
                  :placeholder="placeholder"
                  class="text-xs leading-normal"
                  >
                  </v-select>
              </div>
              <div class="w-full bg-white p-3 pt-0 rounded mt-3" v-if="selected">
                <h5 class="mb-10 mt-0">Select Your Level of Confidence</h5>
                <vue-slider v-model="value" :min="60" :max="99" :tooltip-formatter="formatter" class="my-3" :tooltip="'always'"></vue-slider>
                <a v-on:click="isSure = !isSure" class="text-center commitbutton p-0 py-1 inline-block btn cursor-pointer text-xs w-full shadow-lg mt-1">Save Type <i aria-hidden="true" class="material-icons align-middle text-sm">save</i></a>
              </div>
          </div>
          <div v-if="!isSure" class="flex justify-center flex-col bg-red-600 text-white w-full p-3 absolute top-0 text-sm z-50 h-full text-center" v-click-outside="onClickOutside">
              I am {{ value }}% confident that <span class="underline text-lg">{{ selected.name }}</span> is their Best-Fit Type.  <br>
              <button v-on:click="putItem" type="submit" class="mt-3 btn text-sm bg-white text-red-700 commitbutton mt-1 rounded px-3 py-1">Confirmed</button>
          </div>
        
      </div>
</template>

<script>
import VueSelect from 'vue-select';
import VueSlider from 'vue-slider-component'
import vClickOutside from 'v-click-outside'
import axios from 'axios'

  export default {
        
        components: { VueSelect, VueSlider },

        props: {
            options: '',
            placeholder: {
                default: 'Select Item' 
            },
            route:'',
            idname:'',
            content: '',
            route:'',
            routeparam:'',
            buttonname: {
              default: 'Change',
            },
            buttonicon: {
              default: 'edit',
            },
            buttonsize: {
              default: 'text-xs',
            },
            confirmtext: {
              default: 'Are You Sure?',
            },
            type: '',
            userid: '',
            initialaccuracy: '',
        },

        data() {
          return {
            isHidden: true,
            isSure: true,
            success: false,
            loaded: true,
            name: '',
            selected: '',
            user_id: this.userid,
            value: this.initialaccuracy,
            formatter: '{value}%',
          }
        },
        
        directives: {
          clickOutside: vClickOutside.directive
        },
        
        methods: {
          onClickOutside (event) {
              this.isSure = !this.isSure
          },

          formfocus() {
              document.getElementById("groupName").focus();
          },
          mounted(){
          },

          putItem: function (event) {
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              $( ".commitbutton").addClass( "loading" );
              axios.post(this.route,
                  { accuracy: this.value, user_id: this.user_id, type: this.selected.value }
                ).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            };
          }

        },
      }
</script>
